export const COOKIE_ACCESS_TOKEN = "5gVI-mybiz_access-token";
export const COOKIE_REFRESH_TOKEN = "5gVI-mybiz_refresh-token";
export const COOKIE_ID_TOKEN = "5gVI-mybiz_id_token";
export const COOKIE_ACTIVE_SESSION = "activeSession";
export const COOKIE_IS_LOGIN = "5gVI-mybiz-islogin";
export const COOKIE_PATH = "/";
export const COOKIE_DOMAIN = ".verizon.com";
export const userLoggedIn = {
  SUCCESS: "success",
  FAILED: "failed",
  LOADING: "loading",
};